import { ActivitySpinnerSize, ActivitySpinnerWidget, ButtonType, ButtonWidget, InteractionState } from '@tableau/widgets';
import * as React from 'react';

const spinnerStyle = {
    verticalAlign: 'sub',
    paddingRight: '5px'
};

const buttonStyle: React.CSSProperties = {
    cursor: 'pointer'
};

export class ButtonWithSpinner extends React.PureComponent<ButtonWithSpinner.Props, {}> {

  public render() {

    return (
      <ButtonWidget
        buttonType = {this.props.buttonType}
        disabled = { this.props.disabled }
        handleClick = {this.props.clicked}
        testId = {this.props.testId}
        getContent = {this.getContent.bind(this)}
        style = {buttonStyle}
      />
    );
  }

  private getContent(state: InteractionState): JSX.Element {
    if (this.props.showSpinner) {
        return (
            <div>
                <span style={spinnerStyle} >
                    <ActivitySpinnerWidget
                        spinnerSize = {ActivitySpinnerSize.Small}
                        testId= {'button-icon-spinner'}
                        onDarkBackground = {false}
                    />
                </span>
                <span className="buttonWithSpinnerTitle" > {this.props.title} </span>
            </div>
        );
    }
    return (<span className="buttonWithSpinnerTitle"> {this.props.title} </span>);
  }
}

export namespace ButtonWithSpinner {

  export interface Props {
    readonly buttonType: ButtonType;
    readonly showSpinner?: boolean;
    readonly clicked: () => void;
    readonly disabled?: boolean;
    readonly title?: string;
    readonly testId: string;
  }
}
